import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { PageLayout } from 'components/PageLayout';
import { PhotoSubmissionContent } from './PhotoSubmissionContent';

type ContentProps = {
  geoEventId?: number;
};

const Content = (props: ContentProps): JSX.Element => {
  const { geoEventId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('photoSubmission.title')}</title>
      </Helmet>
      <PhotoSubmissionContent geoEventId={geoEventId} />
    </>
  );
};

export const PhotoSubmission = (
  props: RouteComponentProps<{ geoEventId?: string }>,
): JSX.Element => {
  const {
    match: {
      params: { geoEventId },
    },
  } = props;
  const { t } = useTranslation();

  return (
    <PageLayout
      data-cname="PhotoSubmissionPage"
      headerBarProps={{
        action: geoEventId ? `/i/${geoEventId}` : '/',
        title: t('photoSubmission.title'),
      }}
    >
      <Content geoEventId={geoEventId ? parseInt(geoEventId, 10) : undefined} />
    </PageLayout>
  );
};
